import { useMemo } from 'react';
import { countTextLength } from '@src/services/tts';
import { convertSubtitleTimeToSeconds } from '@src/utils/time';
import {
  calculateRecommendedMaxChars,
  isExceedRecommendedChars,
} from '@src/services/cps';

const DEFAULT_RESULT = {
  isExceeded: false,
  maxRecommended: null,
  currentChars: 0,
  duration: 0,
};

const useRecommendedCharWarning = ({
  text,
  startTime,
  endTime,
  voice,
  speed,
  hasError,
  isFeatureEnabled,
}) =>
  useMemo(() => {
    if (!isFeatureEnabled) return DEFAULT_RESULT;

    const cps = voice?.cps;
    if (!cps || cps <= 0) return DEFAULT_RESULT;

    if (!startTime || !endTime) return DEFAULT_RESULT;

    const startSeconds = convertSubtitleTimeToSeconds(startTime);
    const endSeconds = convertSubtitleTimeToSeconds(endTime);
    const duration = endSeconds - startSeconds;

    if (duration <= 0) return DEFAULT_RESULT;

    if (hasError) return { ...DEFAULT_RESULT, duration };

    const currentSpeed = speed || 1;
    const maxRecommended = calculateRecommendedMaxChars({
      cps,
      speed: currentSpeed,
      duration,
    });

    const currentChars = countTextLength(text || '');
    const isExceeded = isExceedRecommendedChars(currentChars, maxRecommended);

    return {
      isExceeded,
      maxRecommended,
      currentChars,
      duration,
    };
  }, [text, startTime, endTime, voice?.cps, speed, hasError, isFeatureEnabled]);

export default useRecommendedCharWarning;
